/*
 * variant-gallery.js — Complete Dawn-safe version
 * Prevents first color stacking and keeps correct two-image display for all variants
 */

// Ensure gallery starts hidden
document.documentElement.classList.remove("gallery-ready");

document.addEventListener("DOMContentLoaded", () => {
  const product = document.querySelector('[id^="MainProduct-"]');
  if (!product) return;

  const gallery = product.querySelector(".product__media-list");
  if (!gallery) return;

  function showColorImages(color) {
    if (!color) return;

    const imgs = gallery.querySelectorAll(".product__media-item");
    let shown = 0;

    imgs.forEach((item) => {
      const img = item.querySelector("img");
      const alt = img?.alt?.toLowerCase() || "";
      const match = alt.includes(color.toLowerCase());
      item.style.display = match ? "block" : "none";
      if (match) shown++;
    });

    // Fallback if no images matched
    if (shown === 0) imgs.forEach((i) => (i.style.display = "block"));

    // Reveal gallery and trigger Dawn resize
    gallery.classList.add("is-ready");
    document.documentElement.classList.add("gallery-ready");
    setTimeout(() => window.dispatchEvent(new Event("resize")), 150);
  }

  function getCurrentColor() {
    const checkedColor = product.querySelector('input[name*="Color" i]:checked');
    const selectColor = product.querySelector('select[name*="Color" i]');
    return (checkedColor?.value || selectColor?.value || "").trim();
  }

  function waitForGalleryReady(retries = 0) {
    const initColor = getCurrentColor();
    const hasImages = gallery.querySelectorAll("img").length > 0;

    if (initColor && hasImages) {
      showColorImages(initColor);
    } else if (retries < 20) {
      setTimeout(() => waitForGalleryReady(retries + 1), 150);
    } else {
      // Failsafe
      gallery.classList.add("is-ready");
      document.documentElement.classList.add("gallery-ready");
      gallery.querySelectorAll(".product__media-item").forEach(i => (i.style.display = "block"));
    }
  }

  // Start with gallery hidden and wait for Dawn to finish injecting
  gallery.classList.remove("is-ready");
  waitForGalleryReady();

  // Listen for color or variant selection
  product.addEventListener("change", (e) => {
    if (e.target.name?.toLowerCase().includes("color") || e.target.name === "id") {
      const color = getCurrentColor();
      gallery.classList.remove("is-ready");
      document.documentElement.classList.remove("gallery-ready");
      setTimeout(() => showColorImages(color), 250);
    }
  });
});
